import { iconInfoClasses } from "@klantondersteuning/shared/src/constants/icons";
import { parsedHtmlElement } from "../interface/formContentData";

export const getPopupHint = (additionalInformationText?: parsedHtmlElement) => {
  let popupHintInfo = {};
  if (additionalInformationText) {
    popupHintInfo = { content: additionalInformationText };
  }

  return {
    popupHint: additionalInformationText
      ? {
        icon: iconInfoClasses,
        ...popupHintInfo
      }
      : undefined
  };
};